import { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";
import { warn } from "@/lib/log";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user

  useEffect(() => {
    http.get("/auth/me")
      .then((r) => setUser(r.data && r.data.id ? r.data : false))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const logout = async () => { try { await http.post("/auth/logout"); } catch (e) { warn("Logout request failed; clearing session locally", e); } setUser(false); };

  return <AuthContext.Provider value={{ user, setUser, login, logout }}>{children}</AuthContext.Provider>;
}
